<template>
  <div :class="'col-md-' + col" class="input">
    <label>{{ label }} <span v-if="isRequired">*</span></label>
    <div class="input-content">
      <input type="color" v-model="colorValue" @change="updateColor"
             :style="{ background: colorValue }"/>
    </div>
    <span class="input-error" v-if="inputError">Preencha o campo *</span>
  </div>
</template>
<script>
export default {
  name: "inputColor",
  props: {
    label: {
      required: true
    },
    col: {
      required: true,
    },
    isRequired: {
      default: false,
    },
    inputError: {
      default: false,
    }
  },
  data() {
    return {
      colorValue: '#000000'
    }
  },
  methods: {
    updateColor(event) {
      this.$emit('update:colorValue', event.target.value);
    }
  }
}
</script>

<style lang="scss" scoped>

.input {
  position: relative;
  margin-bottom: 20px;

  label {
    font-size: 14px;
    font-weight: 400;
    color: #191919;
    margin-bottom: 4px;

    span {
      font-weight: 400;
      font-size: 14px;
      color: #FF445D;
    }
  }

  &-content {
    width: 75px;

    input[type="color"] {
      border-radius: 4px !important;
      transition: .2s;
      cursor: pointer;
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
      border: 1px solid #FFFFFF;
      width: 100%;
      padding: 17.5px;

      &:hover {
        transition: .2s;
        border: 1px solid #CACACA;
      }
    }

    input[type="color"]::-webkit-color-swatch {
      border: none;
    }

    input[type="color"]::-webkit-color-value {
      border: none;
    }

    input[type="color"]::-moz-color-swatch {
      border: none;
    }

    input[type="color"]::-moz-color-value {
      border: none;
    }
  }

  &-error {
    position: absolute;
    left: 15px;
    bottom: -15px;
    font-size: 11px;
    color: #D9534F;
  }
}

</style>



// WEBPACK FOOTER //
// src/vue/pages/components/inputs/inputColor.vue